"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileButton = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./TileButton.css");
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _sizing = require("@cbhq/cds-common/tokens/sizing");
var _tile = require("@cbhq/cds-common/tokens/tile");
var _cdsUtils = require("@cbhq/cds-utils");
var _illustrations = require("../illustrations");
var _focus = require("../styles/focus");
var _Pressable = require("../system/Pressable");
var _tokens = require("../tokens");
var _linaria = require("../utils/linaria");
var _Tile = require("./Tile");
const _excluded = ["pictogram", "title", "count", "children", "showOverflow"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const pressableStyles = "cds-pressableStyles-p11983em";
const TileButton = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function TileButton(_ref, ref) {
  let pictogram = _ref.pictogram,
    title = _ref.title,
    count = _ref.count,
    children = _ref.children,
    showOverflow = _ref.showOverflow,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if ((0, _cdsUtils.isDevelopment)() && title.trim() === '') {
    // eslint-disable-next-line no-console
    console.warn('Setting an empty title in TileButton violates accessibility and CDS usage guidelines.');
  }
  const tileSize = (0, _useScaleConditional.useScaleConditional)({
    dense: _tile.denseTileSize,
    normal: _tile.tileSize
  });
  const content = (0, _react.useMemo)(() => {
    return children || /*#__PURE__*/_react.default.createElement(_illustrations.Pictogram, {
      name: pictogram,
      scaleMultiplier: _tile.pictogramScaleMultiplier
    });
  }, [children, pictogram]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: `${tileSize}px`,
      /* add gutter to account for the border added by Pressable */
      width: `${tileSize + _sizing.gutter}px`
    }
  }, /*#__PURE__*/_react.default.createElement(_Pressable.Pressable, _extends({
    transparentWhileInactive: true
  }, props, {
    ref: ref,
    noScaleOnPress: true,
    background: "background",
    borderRadius: "roundedLarge",
    className: (0, _linaria.cx)(_focus.insetFocusRing, pressableStyles)
  }), /*#__PURE__*/_react.default.createElement(_Tile.Tile, {
    count: count,
    showOverflow: showOverflow,
    title: title
  }, content)));
}));
exports.TileButton = TileButton;